import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem } from 'primeng/api';
@Component({
    selector: 'scaffold-add-button-menu',
    templateUrl: './add-button-menu.component.html',
    styleUrls: ['./add-button-menu.component.scss'],
    standalone: false
})
export class AddButtonMenuComponent implements OnInit {
  private _types: any[];
  // item: any;
  @Input()
  set types(types) {
    //console.log(types)
    if (types.push) {
      this._types = types;
    } else {
      this._types = [types];
    }
  }
  get types() {
    return this._types;
  }
  @Input() index: number;
  @Input() use_icon = false;
  @Input() disabled = false;
  @Input() blockButton = false;
  private _add_label;
  @Input()
  set add_label(label) {
    this._add_label = label && label.length > 0 ? label : 'Add';
  }
  get add_label() {
    return this._add_label;
  }

  @Output() addNew = new EventEmitter<any>();
  instance = Math.floor(Math.random() * 1000000);

  menuitems: MenuItem[] = [];
  constructor() {}

  ngOnInit() {
    this.menuitems = this.getMenu(this.types);
  }
  /**
   * Creates a nebular menu item list based on custom button input
   * @param types
   */
  getMenu(types: any[]): MenuItem[] {
    const items: MenuItem[] = [];
    types.forEach(type => {
      const button: MenuItem = {
        label: type.label,
        data: {
          defaults: type.new_defaults,
          type: type.type || type.name,
        },
        command: event => this.addItem(event.item.data),
      };
      items.push(button);
    });
    //console.log(items);
    return items;
  }

  addItem(item) {
    console.log(item);
    const event = {
      index: this.index,
      type: item.data.type,
      defaults: item.data.defaults,
    };
    this.addNew.emit(event);
  }
}
